<app-loader [Parent]="this"></app-loader>
@if (Model) {
  <div>
    <app-pageheader>
      <div class="buttons are-small">
        @for (status of Model.AvailableStatusChanges; track status) {
          <button
            class="button is-small mr-1 is-light"
            (click)="changeStatus(status)">
            <i class="fas fa-arrow-right" style="margin-right: 0.5rem;"></i>
            <span>{{status.Name}}</span>
          </button>
        }
      </div>
    </app-pageheader>
    <!-- Warning notification -->
    @if (Model.IsWarning) {
      <div class="notification is-warning is-light mb-4">
        <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
        <strong>Warning Only</strong> — This citation was issued as a warning and does not require payment.
      </div>
    }
    <div class="columns is-multiline">
      <!-- Citation Details - Top Left -->
      <div class="column is-6">
        <article class="panel">
          <div class="panel-heading">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  Citation Details
                </div>
              </div>
              <div class="level-right">
                <button class="button is-info is-light is-small" (click)="viewHistory()">
                  <i class="fas fa-history" style="margin-right: 0.5rem;"></i>
                  <span>View History</span>
                </button>
              </div>
            </div>
          </div>
          <a class="panel-block">
            <span class="label">Issue Date</span>
            <span class="value">{{Model.IssuedDateLocalFriendlyString}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Notice #</span>
            <span class="value">{{Model.Id}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Reference</span>
            <span class="value">{{Model.Reference}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Plate Number</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.PlateNumber}">{{Model.PlateNumber || 'Not Set'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Vehicle Make</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.VehicleMake}">{{Model.VehicleMake || 'Not Set'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Vehicle Colour</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.VehicleColor}">{{Model.VehicleColor || 'Not Set'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Parking Lot</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.ParkingLotName}">{{Model.ParkingLotName || 'Not Set'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Parking Space</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.ParkingSpaceName}">{{Model.ParkingSpaceName || 'Not Set'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Issued By</span>
            <span class="value">{{Model.IssuedByUserName}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Status</span>
            <span class="value">{{Model.Status}}</span>
          </a>
          @if (!Model.IsWarning) {
            <a class="panel-block">
              <span class="label">Total Fees</span>
              <span>{{Model.TotalFee | currency}}</span>
            </a>
          }
          @if (!Model.IsWarning) {
            <a class="panel-block">
              <span class="label">Total Paid</span>
              <span>{{Model.TotalPaid | currency}}</span>
            </a>
          }
          @if (!Model.IsWarning) {
            <a class="panel-block">
              <span class="label">Total Adjustments</span>
              <span>{{getTotalDiscount() | currency}}</span>
            </a>
          }
          <a class="panel-block">
            <span class="label">Outstanding Balance</span>
            <span class="value has-text-weight-bold">
              @if (Model.IsWarning) {
                <s class="has-text-grey">{{Model.TotalFee | currency}}</s>
                <span class="tag is-warning is-small ml-2">Warning</span>
              }
              @if (!Model.IsWarning) {
                <span [ngClass]="{'has-text-danger': Model.TotalOutstanding > 0}">{{Model.TotalOutstanding | currency}}</span>
                @if (Model.IsFrozen) {
                  <span class="icon is-small has-text-info ml-1" title="Fees frozen"><i class="fas fa-snowflake"></i></span>
                }
              }
            </span>
          </a>
          @if (Model.EmailAddress) {
            <a class="panel-block">
              <span class="label">Email Address</span>
              <span class="value">{{Model.EmailAddress}}</span>
            </a>
          }
          @if (Model.ViolationId) {
            <a class="panel-block">
              <span class="label">Origin Violation</span>
              <span class="value">
                <a [routerLink]="['/enforcement/violations', Model.ViolationId]" class="has-text-link" target="_blank">
                  Violation #{{Model.ViolationId}}
                  <i class="fas fa-external-link-alt ml-1"></i>
                </a>
              </span>
            </a>
          }
        </article>
      </div>
      <!-- Infringements - Top Right -->
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Infringements
          </p>
          <div class="table-container p-2">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Infringement</th>
                  <th>Void Reason</th>
                  <th class="has-text-right">Base Fee</th>
                  <th class="has-text-right">Current Fee</th>
                  <th>Appeal</th>
                </tr>
              </thead>
              <tbody>
                @for (infringement of Model.Infringements; track infringement) {
                  <tr [class.has-text-grey-light]="infringement.IsVoided" class="infringement-row">
                    <td>
                      {{infringement.InfringementTypeName}}
                      @if (infringement.IsVoided) {
                        <span class="tag is-dark is-small ml-2">Voided</span>
                      }
                    </td>
                    <td class="void-reason-cell">
                      @if (infringement.IsVoided) {
                        {{infringement.VoidReasonText || '-'}}
                      }
                      @if (!infringement.IsVoided) {
                        <span class="void-placeholder">-</span>
                        <button class="button is-danger is-small void-button"
                          (click)="openVoidModal(infringement)"
                          title="Void this infringement">
                          <span class="icon is-small"><i class="fas fa-ban"></i></span>
                          <span>Void</span>
                        </button>
                      }
                    </td>
                    <td class="has-text-right">
                      @if (infringement.IsVoided) {
                        <s class="has-text-grey">{{infringement.BasePrice | currency}}</s>
                      }
                      @if (!infringement.IsVoided) {
                        {{infringement.BasePrice | currency}}
                      }
                    </td>
                    <td class="has-text-right">
                      @if (infringement.IsVoided) {
                        <s class="has-text-grey">{{infringement.CurrentPrice | currency}}</s>
                      }
                      @if (!infringement.IsVoided) {
                        {{infringement.CurrentPrice | currency}}
                        @if (Model.IsFrozen) {
                          <span class="icon is-small has-text-info" title="Fees frozen"><i class="fas fa-snowflake"></i></span>
                        }
                      }
                    </td>
                    <td>
                      @if (infringement.AppealId) {
                        <a [routerLink]="['/enforcement/citations/appeals', infringement.AppealId]" class="has-text-link">
                          #{{infringement.AppealId}}
                          <span class="tag is-small is-dark ml-1 mr-1">{{infringement.AppealStatus}}</span>
                          <span class="is-size-7 has-text-grey">{{infringement.AppealSubmissionDateLocalFriendlyString}}</span>
                        </a>
                      }
                      @if (!infringement.AppealId) {
                        <span class="has-text-grey-light">-</span>
                      }
                    </td>
                  </tr>
                }
                <tr class="has-background-light">
                  <td colspan="2" class="has-text-weight-bold">Total</td>
                  <td class="has-text-right has-text-grey">{{getBaseFeeTotal() | currency}}</td>
                  <td class="has-text-right has-text-weight-bold">
                    {{Model.TotalFee | currency}}
                    @if (Model.IsFrozen) {
                      <span class="icon is-small has-text-info" title="Fees frozen"><i class="fas fa-snowflake"></i></span>
                    }
                  </td>
                  <td>
                    @if (Model.EscalationSchedule && Model.EscalationSchedule.length > 0) {
                      <button
                        class="button is-small is-light"
                        (click)="showEscalationSchedule = !showEscalationSchedule"
                        title="View fee escalation schedule">
                        <span class="icon is-small"><i class="fas" [ngClass]="showEscalationSchedule ? 'fa-chevron-up' : 'fa-calendar-alt'"></i></span>
                        <span class="is-hidden-mobile">{{showEscalationSchedule ? 'Hide Schedule' : 'Show Schedule'}}</span>
                      </button>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Escalation Schedule (Expandable) -->
          @if (showEscalationSchedule && Model.EscalationSchedule && Model.EscalationSchedule.length > 0) {
            <div class="escalation-schedule-section">
              <div class="escalation-header">
                <span class="has-text-weight-semibold">Fee Schedule</span>
              </div>
              <table class="table is-fullwidth is-striped escalation-table">
                <thead>
                  <tr>
                    <th>Effective Date</th>
                    <th class="has-text-right">Total Amount Due</th>
                  </tr>
                </thead>
                <tbody>
                  @for (escalation of Model.EscalationSchedule; track escalation; let i = $index) {
                    <tr
                      [class.is-current]="i === 0 || (escalation.EffectiveAfterDateLocalFriendlyString && isCurrentEscalation(i))">
                      <td>
                        @if (i === 0) {
                          <span>Issued</span>
                        }
                        @if (i > 0) {
                          <span>{{escalation.EffectiveAfterDateLocalFriendlyString || (escalation.EffectiveAfterDate | date:'mediumDate')}}</span>
                        }
                      </td>
                      <td class="has-text-right has-text-weight-semibold">
                        {{escalation.Amount | currency}}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          <!-- Fee Freeze Section -->
          <div class="p-3 has-background-light freeze-section" #freezeSection [class.freeze-section-highlight]="showFreezeHighlightAfterAdjustment" >
            @if (showFreezeHighlightAfterAdjustment) {
              <strong>Freeze fees to keep the price constant after this adjustment.</strong>
            }
            <!-- Currently Frozen -->
            @if (Model.IsFrozen) {
              <div>
                <div class="notification is-info is-light mb-3">
                  <div class="level is-mobile">
                    <div class="level-left">
                      <div class="level-item">
                        <span class="icon"><i class="fas fa-snowflake"></i></span>
                      </div>
                      <div class="level-item">
                        <div>
                          <strong>Fee Escalation Frozen</strong>
                          <p class="is-size-7 mb-0">
                            @if (Model.IsFrozenIndefinitely) {
                              <span>Frozen indefinitely</span>
                            }
                            @if (!Model.IsFrozenIndefinitely && Model.FrozenUntilLocalFriendlyString) {
                              <span>Frozen until {{Model.FrozenUntilLocalFriendlyString}}</span>
                            }
                            @if (Model.FrozenAtLocalFriendlyString) {
                              <span> (since {{Model.FrozenAtLocalFriendlyString}})</span>
                            }
                          </p>
                          @if (Model.FreezeReason) {
                            <p class="is-size-7 mb-0">
                              <em>Reason: {{Model.FreezeReason}}</em>
                            </p>
                          }
                          @if (Model.FrozenByUserName) {
                            <p class="is-size-7 mb-0 has-text-grey">
                              By {{Model.FrozenByUserName}}
                            </p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small">Reason for removing freeze (optional)</label>
                  <div class="control">
                    <input class="input is-small" type="text" [(ngModel)]="clearFreezeReason" placeholder="Enter reason..." maxlength="512">
                  </div>
                </div>
                <button class="button is-danger is-small" (click)="clearFreeze()" [disabled]="freezeBusy">
                  <span class="icon"><i class="fas fa-fire"></i></span>
                  <span>Remove Freeze</span>
                </button>
              </div>
            }
            <!-- Expired Freeze Notice -->
            @if (!Model.IsFrozen && Model.FrozenUntilLocalFriendlyString && !Model.IsFrozenIndefinitely) {
              <div>
                <p class="is-size-7 has-text-grey mb-3">
                  <span class="icon is-small"><i class="fas fa-clock"></i></span>
                  Freeze expired {{Model.FrozenUntilLocalFriendlyString}}
                </p>
              </div>
            }
            <!-- Not Frozen - Add Freeze Form -->
            @if (!Model.IsFrozen) {
              <div>
                <div class="field">
                  <label class="label is-small">Freeze Type</label>
                  <div class="control">
                    <div class="select is-small is-fullwidth">
                      <select [(ngModel)]="freezeType">
                        <option value="">-- Select freeze type --</option>
                        <option value="indefinite">Freeze Indefinitely</option>
                        <option value="until">Freeze Until Date</option>
                      </select>
                    </div>
                  </div>
                </div>
                @if (freezeType === 'until') {
                  <div class="field">
                    <label class="label is-small">Freeze Until</label>
                    <div class="control">
                      <input class="input is-small" type="date" [(ngModel)]="freezeUntilDate">
                    </div>
                  </div>
                }
                @if (freezeType) {
                  <div class="field">
                    <label class="label is-small">Reason <span class="has-text-danger">*</span></label>
                    <div class="control">
                      <input class="input is-small" type="text" [(ngModel)]="freezeReason" placeholder="Enter reason for freeze..." maxlength="512">
                    </div>
                  </div>
                }
                @if (freezeType) {
                  <button class="button is-info is-small" (click)="applyFreeze()"
                    [disabled]="freezeBusy || !freezeReason || (freezeType === 'until' && !freezeUntilDate)">
                    <span class="icon"><i class="fas fa-snowflake"></i></span>
                    <span>Add Freeze</span>
                  </button>
                }
              </div>
            }
          </div>
        </article>
        <!-- Fee Adjustments -->
        <div class="panel mt-4">
          <div class="panel-heading">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">Fee Adjustments</div>
              </div>
              <button class="button is-small is-primary" (click)="openAdjustmentModal()" [disabled]="cannotAddAdjustment()" >
                <span class="icon is-small"><i class="fas fa-plus"></i></span>
                <span>Add Adjustment</span>
              </button>
            </div>
          </div>
          <div class="panel-block is-block">
            <div class="table-container">
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Reason</th>
                    <th>Adjustment Amount</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  @for (a of Model.Adjustments; track a) {
                    <tr>
                      <td>{{a.CreatedDate | date:'mediumDate'}}</td>
                      <td>{{a.AdjustmentType === 0 ? "Discount" : "Surcharge"}}</td>
                      <td>{{a.Reason}}</td>
                      <td>{{a.Amount | currency}}</td>
                      <td>{{a.CreatedByUserName}}</td>
                    </tr>
                  }
                  @if (Model.Adjustments.length === 0) {
                    <tr>
                      <td colspan="5" class="has-text-centered is-italic is-bold has-text-grey">No adjustments have been made yet</td>
                    </tr>
                  }
                  @if (Model.Adjustments.length > 0) {
                    <tr  class="has-background-light">
                      <td><strong>Total Adjustments</strong></td>
                      <td></td> <td></td>
                      <td><strong>{{ getTotalDiscount() | currency}}</strong></td>
                      <td></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Owner Details (DMV) + Notices (Right Panel) -->
      <div class="column" [ngClass]="showCitationNoticesPanel ? 'is-6' : 'is-12'">
        <article class="panel">
          <div class="panel-heading">
            Owner Details (DMV)
          </div>
          @if (Model.DMVFirstName || Model.DMVLastName || Model.DMVBirthDate || Model.DMVResidentialAddressLine1 || Model.DMVPostalAddressLine1) {
            <div>
              <a class="panel-block">
                <span class="label">Owner Name</span>
                <span class="value" [ngClass]="{'has-text-grey is-italic': !(Model.DMVFirstName || Model.DMVLastName)}">
                  {{((Model.DMVFirstName || '') + ' ' + (Model.DMVMiddleName || '') + ' ' + (Model.DMVLastName || '')).trim() || 'Not Set'}}
                </span>
              </a>
              @if (Model.DMVBirthDate) {
                <a class="panel-block">
                  <span class="label">Birth Date</span>
                  <span class="value">{{Model.DMVBirthDateFriendlyString || Model.DMVBirthDate}}</span>
                </a>
              }
              <a class="panel-block">
                <span class="label">Residential Address</span>
                <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.DMVResidentialAddressLine1}">
                  @if (Model.DMVResidentialAddressLine1) {
                    <div>{{Model.DMVResidentialAddressLine1}}</div>
                    @if (Model.DMVResidentialAddressLine2) {
                      <div>{{Model.DMVResidentialAddressLine2}}</div>
                    }
                    <div>
                      {{Model.DMVResidentialAddressCity}}{{Model.DMVResidentialAddressCity && Model.DMVResidentialAddressPostCode ? ', ' : ''}}
                      {{Model.DMVResidentialAddressPostCode}}
                    </div>
                  } @else {
                    Not Set
                  }
                </span>
              </a>
              <a class="panel-block">
                <span class="label">Postal Address</span>
                <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.DMVPostalAddressLine1}">
                  @if (Model.DMVPostalAddressLine1) {
                    <div>{{Model.DMVPostalAddressLine1}}</div>
                    @if (Model.DMVPostalAddressLine2) {
                      <div>{{Model.DMVPostalAddressLine2}}</div>
                    }
                    <div>
                      {{Model.DMVPostalAddressCity}}{{Model.DMVPostalAddressCity && Model.DMVPostalAddressPostCode ? ', ' : ''}}
                      {{Model.DMVPostalAddressPostCode}}
                    </div>
                  } @else {
                    Not Set
                  }
                </span>
              </a>
              @if (Model.DMVFetchedOnLocalFriendlyString) {
                <a class="panel-block">
                  <span class="label">Fetched On</span>
                  <span class="value">{{Model.DMVFetchedOnLocalFriendlyString}}</span>
                </a>
              }
            </div>
          } @else {
            <div class="panel-block has-text-grey is-italic">
              No DMV owner data on this citation.
            </div>
          }
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <div class="panel-heading">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">Citation Escalations</div>
              </div>
              @if (showCitationNoticesPanel) {
                <div class="level-right">
                  <button class="button is-small is-light" (click)="loadCitationNotices()" [disabled]="noticesLoading || noticeBusy">
                    <span class="icon is-small"><i class="fas fa-rotate"></i></span>
                    <span>Refresh</span>
                  </button>
                </div>
              }
            </div>
          </div>
          <div class="panel-block is-block">
            <ng-template #cannotGenerateNoticesDmvInline>
              <div class="notification is-warning is-light">
                DMV details have not been fetched for this citation yet, so notices can’t be generated.
              </div>
            </ng-template>
            @if (noticesLoading) {
              <div class="has-text-grey is-italic">Loading notices…</div>
            }
            @if (!noticesLoading && !hasNotices) {
              <div class="has-text-grey is-italic">
                No notices generated for this citation yet.
              </div>
            }
            @if (!noticesLoading && hasNotices) {
              <div class="table-container">
                <table class="table is-fullwidth is-striped is-hoverable is-size-7">
                  <thead>
                    <tr>
                      <th>Document</th>
                      <th>Generated On</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (n of citationNotices; track n) {
                      <tr>
                        <td>
                          @if (hasNoticePdf(n)) {
                            <a [href]="noticeUrl(n)" target="_blank" rel="noopener noreferrer">
                              {{noticeTemplateName(n)}}
                            </a>
                          } @else {
                            <span>{{noticeTemplateName(n)}}</span>
                            <span class="tag is-warning is-light is-small ml-1">No PDF</span>
                          }
                        </td>
                        <td>{{noticeGeneratedOn(n)}}</td>
                        <td>{{getNoticeStatusName(n)}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            <div class="notices-footer">
              @if (!canGenerateNoticeLetters) {
                <ng-container *ngTemplateOutlet="cannotGenerateNoticesDmvInline"></ng-container>
              } @else {
                @if (templatesLoaded) {
                  @if (templates?.length) {
                    <div class="generate-pill">
                      <span class="select is-small">
                        <select [(ngModel)]="selectedNoticeTriggerId" [disabled]="noticeBusy || !noticeTriggerGroup">
                          <option [ngValue]="null">-- select notice trigger --</option>
                          <optgroup label="Send Document Template">
                            @for (t of nonCollectionTriggers(); track t) {
                              <option [ngValue]="t.Id">
                                {{ templateName(t.DocumentTemplateId) || t.DocumentTemplateId }} (after {{ t.DaysAfterCreated }} days)
                              </option>
                            }
                          </optgroup>
                          @for (t of collectionTriggers(); track t) {
                            <option [ngValue]="t.Id">
                              Raise to collections (after {{ t.DaysAfterCreated }} days)
                            </option>
                          }
                        </select>
                      </span>
                      <button class="button is-small is-link is-rounded generate-pill-button"
                        [ngClass]="{'is-loading': noticeBusy}"
                        [disabled]="noticeBusy || !noticeTriggerGroup || !selectedNoticeTriggerId"
                        (click)="generateNoticeLetter()">
                        <span class="icon is-small"><i class="fas fa-check"></i></span>
                        <span>Trigger</span>
                      </button>
                    </div>
                  } @else {
                    <div class="notification is-warning is-light">
                      No citation document templates are available for this organization.
                    </div>
                  }
                }
              }
            </div>
          </div>
          @if (Model?.FinalNoticeGeneratedOnLocalFriendlyString || Model?.FinalNoticeDueOnLocalFriendlyString || Model?.FinalNoticeTag) {
            <div class="panel-block is-block">
              <hr style="margin: 0.5rem 0;" />
              <div class="content" style="margin: 0;">
                <div><strong>Final Escalation Generated On:</strong> {{Model?.FinalNoticeGeneratedOnLocalFriendlyString || '—'}}</div>
                <div><strong>Final Due Date:</strong> {{Model?.FinalNoticeDueOnLocalFriendlyString || '—'}}</div>
                @if (Model?.FinalNoticeTag) {
                  <div class="tag is-danger is-light" style="margin-top: 0.25rem;">
                    {{Model?.FinalNoticeTag}}
                  </div>
                }
              </div>
            </div>
          }
        </article>
      </div>
      <!-- Images -->
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Images
          </p>
          @if (Model.CitationMedia?.length) {
            <div class="p-2">
              <div class="columns is-multiline is-mobile m-0">
                @for (media of Model.CitationMedia; track media) {
                  <div class="column is-2-desktop is-3-tablet is-4-mobile p-1">
                    <div style="margin: 0;">
                      <app-media-thumbnail
                        [MediaId]="media.MediaId"
                        [ThumbnailWidth]="'100%'"
                        [ThumbnailHeight]="'120px'"
                        [Title]="'Citation Photo'"
                        style="margin: 0 !important;">
                      </app-media-thumbnail>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (!Model.CitationMedia?.length) {
            <div class="p-4 has-text-centered">
              <p class="is-italic has-text-grey">No media items associated with this citation</p>
            </div>
          }
        </article>
      </div>
      <!-- Payments -->
      <div class="column is-6">
        <article class="panel">
          <div class="panel-heading">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">Payments</div>
              </div>
              <div class="level-right">
                @if (!Model.IsWarning) {
                  <button
                    class="button is-primary is-small"
                    (click)="MakeManualPayment()">
                    <span class="icon is-small"><i class="fas fa-plus"></i></span>
                    <span>Add Manual Payment</span>
                  </button>
                }
              </div>
            </div>
          </div>
          <div class="table-container p-2">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Account Txn</th>
                  <th>Reference</th>
                  <th class="has-text-right">Amount</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (payment of Model.CitationPayments; track payment) {
                  <tr>
                    <td>{{payment.TransactionDateLocalFriendlyString}}</td>
                    <td>
                      @if (payment.AccountTransactionId && payment.AccountTransactionId > 0) {
                        <span>
                          {{payment.AccountTransactionId}}
                        </span>
                      } @else {
                        —
                      }
                    </td>
                    <td style="max-width: 260px;">
                      @if (!payment.IsManualPayment) {
                        @if (payment.TransactionReference; as tr) {
                          <div class="is-size-7 has-text-grey-dark" style="word-break: break-word;">
                            {{tr}}
                          </div>
                        }
                      }
                      @if (payment.PaymentProviderReference; as ppr) {
                        <div class="is-size-7 has-text-grey" style="word-break: break-word;">
                          {{ppr}}
                        </div>
                      }
                      @if ((payment.IsManualPayment || !payment.TransactionReference) && !payment.PaymentProviderReference) {
                        <div class="has-text-grey">—</div>
                      }
                    </td>
                    <td class="has-text-right">{{payment.AmountPaidString}}</td>
                    <td class="has-text-right">
                      <!-- Manual payments: receipt only -->
                      @if (payment.IsManualPayment) {
                        <a [href]="payment.ReceiptURL" target="_blank" rel="noopener noreferrer" class="button is-primary is-small">
                          Receipt
                        </a>
                      } @else {
                        <a [href]="payment.ReceiptURL" target="_blank" rel="noopener noreferrer" class="button is-primary is-small mr-2">
                          Receipt
                        </a>
                        @if (!payment.IsRefund) {
                          <button
                            class="button is-primary is-small"
                            (click)="RecordRefund(payment)">
                            Record Refund
                          </button>
                        }
                      }
                      <!-- Non-manual payments: receipt + refund (when eligible) -->
                    </td>
                  </tr>
                }
                @if (!Model.CitationPayments?.length) {
                  <tr>
                    <td colspan="5" class="has-text-centered is-italic has-text-grey">No payments have been made</td>
                  </tr>
                }
                @if (Model.CitationPayments?.length) {
                  <tr class="has-background-light">
                    <td colspan="3" class="has-text-weight-bold">Total Paid</td>
                    <td class="has-text-right has-text-weight-bold">{{Model.TotalPaid | currency}}</td>
                    <td></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </article>
      </div>
      <!-- Notes - Full Width at Bottom -->
      <div class="column is-12">
        <article class="panel">
          <div class="panel-heading">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  Notes
                </div>
              </div>
              <div class="level-right">
                <button class="button is-primary is-small" (click)="addNote()" [disabled]="noteBusy">
                  <span class="icon"><i class="fas fa-plus"></i></span>
                  <span>Add Note</span>
                </button>
              </div>
            </div>
          </div>
          <div class="panel-block is-block">
            @if (Model.Notes?.length) {
              <div class="notes-list">
                @for (note of Model.Notes; track note) {
                  <div class="note-item">
                    <div class="note-header">
                      <span class="note-date">{{note.CreatedDateLocalFriendlyString}}</span>
                      <span class="note-author">{{note.CreatedByUserName || 'Unknown User'}}</span>
                    </div>
                    <div class="note-content">{{note.Content}}</div>
                  </div>
                }
              </div>
            }
            @if (!Model.Notes?.length) {
              <div class="has-text-centered has-text-grey py-4">
                <span class="icon is-medium"><i class="fas fa-sticky-note"></i></span>
                <p class="mt-2">No notes have been added to this citation.</p>
              </div>
            }
          </div>
        </article>
      </div>
    </div>
  </div>
}
